import meta from './en/meta';
import layout from './en/layout';
import home from './en/home';
import membersPage from './en/membersPage';
import publicationsPage from './en/publicationsPage';
import teachingPage from './en/teachingPage';
import openingPage from './en/openingPage';
import notFound from './en/notFoundPage';
import router from './en/router';

export default {
  meta,
  layout,
  home,
  membersPage,
  publicationsPage,
  teachingPage,
  openingPage,
  notFound,
  router,
};
